































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import CreateNoteCategoryRequest from '@/models/NoteCategories/CreateNoteCategoryRequest';
import NoteCategoryDto from '@/models/NoteCategories/NoteCategoryDto';

@Component({
    name: 'NoteCategoryCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new NoteCategoryDto();


  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new NoteCategoryDto();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }


  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new CreateNoteCategoryRequest()
    request.name = this.entity.name;
    request.isEnabledOnWorkerGeneral = this.entity.isEnabledOnWorkerGeneral;
    request.isEnabledOnWorkerCall = this.entity.isEnabledOnWorkerCall;
    request.isEnabledOnWorkerMeeting = this.entity.isEnabledOnWorkerMeeting;
    request.isEnabledOnCompanyGeneral = this.entity.isEnabledOnCompanyGeneral;
    request.isEnabledOnCompanyCall = this.entity.isEnabledOnCompanyCall;
    request.isEnabledOnCompanyMeeting = this.entity.isEnabledOnCompanyMeeting;
    request.isEnabledOnLocationGeneral = this.entity.isEnabledOnLocationGeneral;
    request.isEnabledOnLocationCall = this.entity.isEnabledOnLocationCall;
    request.isEnabledOnLocationMeeting = this.entity.isEnabledOnLocationMeeting;
    request.isEnabledOnContactGeneral = this.entity.isEnabledOnContactGeneral;
    request.isEnabledOnContactCall = this.entity.isEnabledOnContactCall;
    request.isEnabledOnContactMeeting = this.entity.isEnabledOnContactMeeting;
    request.isEnabledOnCampaignGeneral = this.entity.isEnabledOnCampaignGeneral;
    request.isEnabledOnCampaignCall = this.entity.isEnabledOnCampaignCall;
    request.isEnabledOnCampaignMeeting = this.entity.isEnabledOnCampaignMeeting;
    request.isEnabledOnJobGeneral = this.entity.isEnabledOnJobGeneral;
    request.isEnabledOnJobCall = this.entity.isEnabledOnJobCall;
    request.isEnabledOnJobMeeting = this.entity.isEnabledOnJobMeeting;
    request.isEnabledOnBookingGeneral = this.entity.isEnabledOnBookingGeneral;
    request.isEnabledOnBookingCall = this.entity.isEnabledOnBookingCall;
    request.isEnabledOnBookingMeeting = this.entity.isEnabledOnBookingMeeting;
    await AgencySettingsModule.createNoteCategory(request);
    this.dialog = false;
  }
}
